import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';

export const deleteMe = async () => {
  const user = store.getState().userInfos.userInfos;
  const response = await keycloakAxios.delete(`user/${user._id}`);

  if (response.status >= 300) {
    throw new Error(
      `Error deleting user profile: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
